import { FC, useEffect, useMemo, useRef, useState } from "react";
import { useApp } from "../../../context/useApp";
import { ShiftSelectionWithTables } from "../../ShiftSelectionWithTables";
import { ProductsSelection } from "../../ProductsSelection";
import { Summary } from "./Summary";
import { _, load } from "../../../utils/helpers";//eslint-disable-line -- is used but in comented code
import { Zones } from "./Zones";
import { Icon } from "../../../parts/Icon";
import { DEFAULT_BOOKING_INSTRUCTIONS, ROUTES, SCREEN_BREAKPOINT_2, timeOuts } from "../../../utils/symbols"; //eslint-disable-line -- are used but in comented code

export const Aside: FC = () => {

    const {
        state: {booking, forcedRenders},
    } = useApp()

    const [forceHidden, setForceHidden] = useState(false)

    const asideContentRef = useRef<HTMLDivElement>(null)
    const lastBookingStep = useRef(booking.step)
    const renderTicketInstructions = useMemo(() => {

        // change: show always
        // const { ticketsShown } = load('localStorage', 'booking-instructions', DEFAULT_BOOKING_INSTRUCTIONS)
        return booking.step === 'tickets' && booking.pax === 0 && !forceHidden

    }, [forcedRenders, forceHidden])//eslint-disable-line
    
    const renderShiftSelction = (booking.step === 'shift')
    const renderZones = (booking.step === 'tickets')
    const renderProductsSelection = (['products', 'personal-details', 'payment'].includes(booking.step))
    const renderSummary = (['tickets', 'products'].includes(booking.step))

    useEffect(() => {
        
        //reset aside scroll to top when changing step
        if (booking.step !== lastBookingStep.current && asideContentRef.current)
            asideContentRef.current.scrollTo({top: 0, left: 0, behavior: 'smooth'})

        lastBookingStep.current = booking.step

    }, [forcedRenders])//eslint-disable-line

    useEffect(() => {
        if (renderTicketInstructions) {
            timeOuts.set('hide-instructions', () => setForceHidden(true), 1000 * 8)
        }
    }, [renderTicketInstructions])

    return (
        <>
        <div 
            className={`df fd-c aifs aside table-layout-aside pb-12 h-100 p-r ${renderTicketInstructions ? 'ticket-instructions-rendered' : ''}`}
            // aria-label={ariaLabel}
        >
            <div className={`ticket-instructions df aic p-a ${renderTicketInstructions ? 'ticket-instructions-rendered' : ''}`}>
                <Icon icon="slab" className="p-a"/>
                <Icon icon="pointer" className="p-a"/>
                <p className="instruction-text">{_('3zo_selec_z')}</p>
            </div>
            <div ref={asideContentRef} className="w-100 h-100 aside-content px-10">
                {renderShiftSelction && (<ShiftSelectionWithTables label={_("2sh_selec_s")} />)}
                {renderZones && (<Zones />)}
                {renderProductsSelection && (<ProductsSelection />)}
            </div>
        </div>
        {renderSummary && (<Summary />)}
        </>
    )
}